// initial state
import * as base from "./base.js";
const waterName = "/admin/api/water";

const obj = base.setBaseUrl("water", waterName);
const obj1 = base.setBaseUrl("pass", waterName);
const a = Object.assign(obj, { obj1 });
export default a;
